import { render, staticRenderFns } from "./dispose.vue?vue&type=template&id=6505fb57&"
import script from "./dispose.vue?vue&type=script&lang=js&"
export * from "./dispose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6505fb57')) {
      api.createRecord('6505fb57', component.options)
    } else {
      api.reload('6505fb57', component.options)
    }
    module.hot.accept("./dispose.vue?vue&type=template&id=6505fb57&", function () {
      api.rerender('6505fb57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/complaintManage/complaintQuery/dispose.vue"
export default component.exports